import React from 'react';
import { Col, FormInstance, Row } from 'components';
import { useContactFieldManager } from 'components/common/ContactFieldManager/useContactFieldManager';
import { ContactInfoCardDataType } from 'typings/form';
import { ContactInfoCard } from './ContactInfoCard';
import { ContactInfoForm } from './ContactInfoForm';

export interface IContactFieldManager {
  form: FormInstance;
  modalState: boolean;
  dataToEdit?: ContactInfoCardDataType[];
  onCancel?: () => void;
}

export const ContactFieldManager = React.memo((props: IContactFieldManager) => {
  const { form, modalState, dataToEdit } = props;
  const {
    editId,
    onContactRowStateChange,
    onContactRowEdit,
    onContactRowRemove,
    contacts,
    onContactRowCancel,
    onContactRowSave,
  } = useContactFieldManager({ form, modalState, dataToEdit });
  return (
    <Row gutter={[0, 20]}>
      {!!contacts?.length && (
        <Col span={24}>
          <Row gutter={[0, 4]} style={{ maxHeight: '300px', overflowX: 'auto' }}>
            {contacts.map((_field: ContactInfoCardDataType) => (
              <Col span={24} key={_field.id}>
                <ContactInfoCard
                  data={_field}
                  form={form}
                  isEditeMode={_field.id === editId}
                  onContactRowEdit={onContactRowEdit}
                  onContactRowRemove={onContactRowRemove}
                  onContactRowStateChange={onContactRowStateChange}
                  onContactRowSave={onContactRowSave}
                />
              </Col>
            ))}
          </Row>
        </Col>
      )}
      <Col span={24}>
        <ContactInfoForm onSave={onContactRowSave} onCancel={onContactRowCancel} form={form} />
      </Col>
    </Row>
  );
});
